import { getSession } from './auth';
import { setupInterceptors } from './axios';

export const setupTokenRefresh = async () => {
  const accessToken = await getSession()
  if(accessToken) setupInterceptors(accessToken);
};
